import React, { useEffect, useState, useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { Card } from "react-bootstrap";
import {
  DialogActions,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import DialogLayout from "../../../../partials/content/DialogLayout";
import { Search, Today, CalendarMonth } from "@mui/icons-material";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import Illustration from "../../../../partials/content/Illustration";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import SearchFiscalYear from "../../setup/finance/searchFiscalYear";
import SearchFiscalPeriod from "../../setup/finance/searchFiscalPeriod";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getSalesTaxReport } from "../../../../services/finance/financeReportService";
import NumberFormat from "react-number-format";
import { formatDate } from "../../../../utils/utils";
import { DateTime } from "luxon";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
function SalesTax(props) {
  const { currentFiscalYear, currentFiscalPeriod, reload } = useGlobalData();
  const selectParamOp = useRef(null);
  const [salesTax, setSalesTax] = useState([]);
  const [searchByFiscalYear, setSearchByFiscalYear] = useState(false);
  const [openSearchFiscalYear, setOpenSearchFiscalYear] = useState(false);
  const [openSearchFiscalPeriod, setOpenSearchFiscalPeriod] = useState(false);

  const [fiscalYear, setFiscalYear] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalPeriod, setFiscalPeriod] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );

  useEffect(() => {
    if (searchByFiscalYear === true && fiscalYear.ID > 0) {
      getSalesTaxData(fiscalYear.ID, 0, 0);
    } else if (
      searchByFiscalYear === false &&
      fiscalPeriod.year > 0 &&
      fiscalPeriod.month > 0
    ) {
      getSalesTaxData(0, fiscalPeriod.year, fiscalPeriod.month);
    }
  }, [reload]);

  return (
    <React.Fragment>
      <OverlayPanel
        ref={selectParamOp}
        showCloseIcon
        dismissable={false}
        id="overlay_panel"
        style={{ width: "450px" }}
        className="overlaypanel-demo"
      >
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <Card>
              <Card.Header>
                <i className="fas fa-filter"></i>
                <span>
                  <strong>Filter Selection</strong>
                </span>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    {searchByFiscalYear === true ? (
                      <TextField
                        id="fiscalYear"
                        label="Fiscal Year"
                        value={
                          fiscalYear.startMonthName +
                          " " +
                          fiscalYear.year +
                          " - " +
                          fiscalYear.endMonthName +
                          " " +
                          fiscalYear.yearTo
                        }
                        style={{ width: "100%" }}
                        variant="outlined"
                        size="small"
                        margin="normal"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <BootstrapTooltip title="Search">
                                <IconButton
                                  type="button"
                                  aria-label="Search"
                                  onClick={() => {
                                    setOpenSearchFiscalYear(true);
                                  }}
                                  edge="end"
                                >
                                  <Search />
                                </IconButton>
                              </BootstrapTooltip>
                              <BootstrapTooltip title="Search By Fiscal Period">
                                <IconButton
                                  type="button"
                                  aria-label="SearchBy"
                                  onClick={() => {
                                    setSearchByFiscalYear(false);
                                  }}
                                  edge="end"
                                >
                                  <Today />
                                </IconButton>
                              </BootstrapTooltip>
                            </InputAdornment>
                          ),
                          readOnly: true,
                        }}
                      />
                    ) : (
                      <TextField
                        id="fiscalPeriod"
                        label="Fiscal Period"
                        value={fiscalPeriod.monthName + " " + fiscalPeriod.year}
                        style={{ width: "100%" }}
                        variant="outlined"
                        size="small"
                        margin="normal"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <BootstrapTooltip title="Search">
                                <IconButton
                                  type="button"
                                  aria-label="Search"
                                  onClick={() => {
                                    setOpenSearchFiscalPeriod(true);
                                  }}
                                  edge="end"
                                >
                                  <Search />
                                </IconButton>
                              </BootstrapTooltip>
                              <BootstrapTooltip title="Search By Fiscal Year">
                                <IconButton
                                  type="button"
                                  aria-label="SearchBy"
                                  onClick={() => {
                                    setSearchByFiscalYear(true);
                                    if (currentFiscalYear.ID > 0) {
                                      setFiscalYear(currentFiscalYear);
                                    }
                                  }}
                                  edge="end"
                                >
                                  <CalendarMonth />
                                </IconButton>
                              </BootstrapTooltip>
                            </InputAdornment>
                          ),
                          readOnly: true,
                        }}
                      />
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <button
              type="button"
              className="btn btn-success btn-md btn-pill btn-bold float-right"
              onClick={() => {
                if (searchByFiscalYear === true && fiscalYear.ID > 0) {
                  getSalesTaxData(fiscalYear.ID, 0, 0);
                } else if (
                  searchByFiscalYear === false &&
                  fiscalPeriod.year > 0 &&
                  fiscalPeriod.month > 0
                ) {
                  getSalesTaxData(0, fiscalPeriod.year, fiscalPeriod.month);
                }
              }}
            >
              <i className="fas fa-search"></i>
              Get Sales Tax
            </button>
          </div>
        </div>
      </OverlayPanel>
      {salesTax.length ? (
        <React.Fragment>
          <CustomDataTable
            data={salesTax}
            onRefreshData={() => {
              if (searchByFiscalYear === true && fiscalYear.ID > 0) {
                getSalesTaxData(fiscalYear.ID, 0, 0);
              } else if (
                searchByFiscalYear === false &&
                fiscalPeriod.year > 0 &&
                fiscalPeriod.month > 0
              ) {
                getSalesTaxData(0, fiscalPeriod.year, fiscalPeriod.month);
              }
            }}
            buttons={[
              {
                name: "Filter",
                onClick: (e) => {
                  selectParamOp.current.toggle(e);
                },
                icon: "fas fa-search",
                color: "info",
              },
            ]}
            columns={[
              {
                header: "A/R Invoice ID",
                field: "invoiceCode",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Customer Name",
                field: "customerName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.customerName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Taxpayer ID",
                field: "taxpayerID",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.taxpayerID} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Invoice Date",
                field: "invoiceDate",
                body: (rowData) => formatDate(rowData.invoiceDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Invoice Amount",
                field: "invoiceAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.invoiceAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Taxable Amount",
                field: "taxableAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.taxableAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Tax Rate",
                field: "taxRate",
                body: (rowData) => (
                  <div className="float-right">{rowData.taxRate}%</div>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Tax Amount",
                field: "taxAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.taxAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Payment.png"
            description={`You don't have any Sales Tax for current data selection!`}
            guidance={`Hint: Try to filter another data selection to get some results`}
            descriptionLeftIcon="fas fa-info-circle kt-font-info"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-info btn-md btn-pill btn-bold mx-1"
              onClick={(e) => {
                selectParamOp.current.toggle(e);
              }}
            >
              <i className="fas fa-search"></i>
              Filter
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openSearchFiscalYear}
        title="Search Fiscal Year"
        onCloseDialog={() => {
          setOpenSearchFiscalYear(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalYear
          onSelectFiscalYear={(fiscalYear) => {
            setFiscalYear({
              ID: fiscalYear.ID,
              year: fiscalYear.year,
              yearTo: fiscalYear.yearTo,
              startMonth: fiscalYear.startMonth,
              startMonthName: fiscalYear.startMonthName,
              endMonth: fiscalYear.endMonth,
              endMonthName: fiscalYear.endMonthName,
            });
            setOpenSearchFiscalYear(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalYear(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchFiscalPeriod}
        title="Search Fiscal Period"
        onCloseDialog={() => {
          setOpenSearchFiscalPeriod(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalPeriod
          onSelectFiscalPeriod={(fiscalPeriod) => {
            setFiscalPeriod({
              ID: fiscalPeriod.ID,
              fiscalYearID: fiscalPeriod.fiscalYearID,
              year: fiscalPeriod.year,
              month: fiscalPeriod.month,
              monthName: fiscalPeriod.monthName,
              statusID: fiscalPeriod.statusID,
            });
            setOpenSearchFiscalPeriod(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalPeriod(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  async function getSalesTaxData(
    fiscalYearID = 0,
    fiscalYear = DateTime.now().year,
    fiscalPeriod = DateTime.now().month
  ) {
    const response = await getSalesTaxReport(
      fiscalYearID,
      fiscalYear,
      fiscalPeriod
    );
    const { data } = response.data;
    setSalesTax(data.salesTaxReport);
  }
}

export default SalesTax;
